import React from 'react'
import "./NoSlots.css"
function NoSlots() {
  return (
    <div className='noSlotsContainer'>No Slots Available</div>
  )
}

export default NoSlots